import React, { Component } from 'react'
import { observer, Provider } from 'mobx-react'
import { RouterView } from '@merchant-backend/common-components'
import SearchBar from './SearchBar'
import List from './List'
import Store from './store'
import { isSiDaTeam } from '@util'
import InViteModal from './InviteModal'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'hljd'
import styles from './style.module.less'
import mainStore from '@components/Main/store'
import { hashHistory } from 'react-router'
import { Alert } from 'hljd'

// 页面排版：适配视觉新规范
const PAGE_LAYOUT_CONFIG = {
  separator: '/',
  viewStyle: {
    margin: 0,
    minHeight: '100%',
    backgroundColor: '#F2F3F6'
  },
  headerStyle: {
    padding: '16px 0 0 24px',
    backgroundColor: '#FFF',
    flexBasis: '32px'
  },
  contentStyle: {
    marginTop: 0,
    backgroundColor: '#F2F3F6'
  },
  titleStyle: {
    height: '58px',
    fontSize: '18px',
    color: '#000',
    paddingLeft: '24px',
    backgroundColor: '#FFF',
    border: 0
  },
  bodyStyle: {
    padding: '16px',
    backgroundColor: '#F2F3F6'
  }
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    const { inviteModalStore } = this.store
    const {
      merchantInfo: { ultimate_member_count }
    } = mainStore
    return (
      <Provider store={this.store}>
        <RouterView title="团队成员" {...PAGE_LAYOUT_CONFIG}>
          <div>
            {/* 页面顶部提示条 */}
            {isSiDaTeam() &&
              ultimate_member_count < 3 && (
                <div className={styles.head_wrap}>
                  <Alert
                    showIcon
                    icon={<ExclamationCircleFilled />}
                    message="当前团队店铺状态异常"
                    description="无法在用户APP端显示，请确保团队至少有3位开通个人商家服务（付费）且有套餐的成员。"
                    type="warning"
                  />
                </div>
              )}
            <div className={styles.content_wrap}>
              {/* 页面操作按钮 */}
              <div className={styles.searchBar_wrap}>
                <SearchBar className={styles.searchBar} />
                {isSiDaTeam() ? (
                  <div>
                    <Button onClick={inviteModalStore.openModal}>
                      邀请成员
                    </Button>

                    {isSiDaTeam() && (
                      <Tooltip
                        visible
                        placement="topRight"
                        overlayStyle={{ zIndex: 999 }}
                        getPopupContainer={container =>
                          container?.parentNode || document.body
                        }
                        title={
                          '创建成员信息成功后，请通知成员根据短信链接提示提交认证材料。'
                        }
                      >
                        <Button
                          type="primary"
                          onClick={() =>
                            hashHistory.push(
                              '/localMerchant/groupMember/create'
                            )
                          }
                          style={{ marginLeft: 10 }}
                        >
                          创建成员
                        </Button>
                      </Tooltip>
                    )}
                    <InViteModal />
                    <br />
                  </div>
                ) : null}
              </div>
              {/* 页面list */}
              <List />
            </div>
          </div>
        </RouterView>
      </Provider>
    )
  }
}
